export interface UploadStats {
  nbLinesTotal: number;
  nbLinesCreate: number;
  nbLinesUpdate: number;
  nbLinesError: number;
}

export interface UploadStatus {
  status: UploadState;
  dateBegin: Date;
  dateLastUpdate?: Date;
  dateEnd?: Date;
  stats: UploadStats;
  user: string; // Stores the users email
  brandId: string;
  errors: any[];
}

export type UploadType = 'uploadPartners';

// The value 'start' is only present on the frontend and never in any Azure Function
export type UploadState = 'start' | 'progress' | 'done' | 'failed';

export function isUploadStatusRunning(status: UploadStatus) {
  return status?.status === 'start' || status?.status === 'progress';
}
